import React from "react";
import cl from "./Footer.module.css";
import { NavLink } from "react-router-dom";

const Footer = (props) => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className={cl.app_footer}>
      <div className={cl.app_footer_main}>
        <div
          className={cl.app_footer_links}
          style={{
            borderRight: "1px solid grey",
            paddingRight: "20px",
            marginBottom: "20px",
          }}
        >
          <p style={{ fontSize: "20px", marginBottom: "10px" }}>Negozio</p>
          <NavLink className={cl.footer_link} to="">
            Casa
          </NavLink>
          <NavLink className={cl.footer_link} to="/about">
            Informazioni
          </NavLink>
          <NavLink className={cl.footer_link} to="/products">
            Prodotti
          </NavLink>
          <NavLink className={cl.footer_link} to="/contacts">
            Contatti
          </NavLink>
        </div>
        <div
          className={cl.app_footer_links}
          style={{
            borderRight: "1px solid grey",
            paddingRight: "20px",
            marginBottom: "20px",
          }}
        >
          <p style={{ fontSize: "20px", marginBottom: "10px" }}>
            Politica del Negozio
          </p>
          <NavLink className={cl.footer_link} to="/policy">
            Informativa sulla privacy
          </NavLink>
          <NavLink className={cl.footer_link} to="/terms">
            Termini di servizio
          </NavLink>
          <NavLink className={cl.footer_link} to="/refund-policy">
            Politica di rimborso
          </NavLink>
          <NavLink className={cl.footer_link} to="/shipping-policy">
            Politica di Spedizione
          </NavLink>
          <NavLink className={cl.footer_link} to="/cookies-policy ">
            Politica sui Cookie
          </NavLink>
        </div>
        <div className={cl.app_footer_info}>
          <img
            src="https://cdn.icon-icons.com/icons2/1186/PNG/512/1490135017-visa_82256.png"
            alt="Visa"
          />
          <img
            src="https://www.iconarchive.com/download/i76278/designbolts/credit-card-payment/Master-Card.ico"
            alt="Master Card"
          />
        </div>
      </div>
      <div className={cl.app_footer_bottom_line}>
        <p>
          &#169; {currentYear} by {props.shopName}
        </p>
      </div>
    </footer>
  );
};

export default Footer;
